"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToPage = exports.fillPagesTo = void 0;
function fillPagesTo(list, num = 0) {
    const res = [...list];
    for (let i = 0; i <= num; i++) {
        if (!res[i])
            res[i] = [];
    }
    return res;
}
exports.fillPagesTo = fillPagesTo;
function addToPage(section, item, { pageId, indexOnPage }) {
    section.list = fillPagesTo(section.list, pageId);
    if (typeof indexOnPage !== 'undefined')
        section.list[pageId][indexOnPage] = item;
    else
        section.list[pageId].push(item);
    return section;
}
exports.addToPage = addToPage;
//# sourceMappingURL=pages.js.map